export default __webpack_public_path__ + "static/loupe-navigation_h264-e5062ae257e234016b4cd1b5dca489d4.mp4";